// CE levels follow Caspio's model: an evaluation's "after" is the FULL set of levels held once it
// was done ([2,4,5] -> [2,4,5,6] means 6 was granted), so the latest evaluation's "after" is the
// engineer's current levels and what one evaluation granted is its after minus its before.

export const CE_LEVEL_LABELS = {
  1: '1 Require Training',
  2: '2 Application Review',
  3: '3 Conduct Evaluation with Supervision',
  4: '4 Conduct Evaluation without Supervision',
  5: '5 Technical Review and Certification decision',
  6: '6 Conduct Audit/Inspection',
  7: '7 Lead Auditor',
  8: 'Not Applicable',
  9: 'Eligible for Second Review',
  11: 'Inspection Coordinator',
}

const toId = level => Number(typeof level === 'object' && level !== null ? level.id : level)

// Level ids of an evaluation side, from the multi-level list or, failing that, the single level.
export function levelIds(levels, single) {
  let ids = []
  if (Array.isArray(levels) && levels.length) {
    ids = levels.map(toId)
  } else if (single) {
    ids = [toId(single)]
  }
  return [...new Set(ids.filter(Boolean))].sort((a, b) => a - b)
}

export function levelLabel(id, fallback) {
  return CE_LEVEL_LABELS[id] || fallback || String(id)
}

// What one evaluation changed: levels added and levels no longer held.
export function levelChange(before, after) {
  return {
    added: after.filter(id => !before.includes(id)),
    removed: before.filter(id => !after.includes(id)),
  }
}

// One line describing an evaluation: "Started with ...", "Granted ...", or "No new level".
export function describeChange(before, after, isFirst) {
  const { added, removed } = levelChange(before, after)
  // The first evaluation on record: say where the engineer started, unless it granted something
  // on top of real levels already held.
  if (isFirst && (!added.length || !before.filter(id => id !== 1 && id !== 8).length)) {
    return `Started with: ${after.map(id => levelLabel(id)).join(', ')}`
  }
  const parts = []
  if (added.length) parts.push(`Granted: ${added.map(id => levelLabel(id)).join(', ')}`)
  if (removed.length) parts.push(`Removed: ${removed.map(id => levelLabel(id)).join(', ')}`)
  return parts.length ? parts.join(' | ') : 'No new level'
}
